import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import './plugins/element.js'
import { firestorePlugin } from 'vuefire'

Vue.use(firestorePlugin)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
